module.exports = __webpack_public_path__ + "static/media/dexter.30227505.jpg";